import React from 'react';
import './Xbutton.scss';

const Xbutton = ({ fixed, onClose, sizeM, isBlack, isWhite, isCircleBorder = true }) => {
  return (
    <div
      onClick={onClose}
      className={
        (isCircleBorder ? "top-navbar--circle " : "") +
        "noselect Xbutton " +
        (sizeM ? "sizeM " : "") +
        (fixed ? "fixed " : "") +
        (isBlack ? "Xbutton--black " : "") +
        (isWhite ? "Xbutton--white " : "") +
        (!isCircleBorder ? "Xbutton--no-border " : "")
      }
    >
      <img src="/assets/icons/iconX.svg" alt="Close" />
    </div>
  );
};

export default Xbutton;
